var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Records"},[_c('v-container',{staticClass:"mt-5"},[_c('RecordsTable',{attrs:{"records":_vm.records}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }